export enum activityActionTypes {
	START_CLIENT_LOGS_DATA_LOADING = 'START_CLIENT_LOGS_DATA_LOADING',
	FETCH_CLIENT_LOGS_DATA = 'FETCH_CLIENT_LOGS_DATA',
	FETCH_FAIL = 'FETCH_FAIL'
}
